export const sdScan059 = 'a/testHiddenImage.'